import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "flex flex-end" }

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { useRtfix, useUser } from '@/store'
import { request } from '@/config/request/interceptors'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const visible = ref(false)

const open = () => (visible.value = true)
const close = () => (visible.value = false)

const user = useUser()
/** 返回true则下单继续往下走 */
const check = async () => {
  if (user.membership.templateLevel === 0) {
    const { data: { currentAvailableQuantity } = {} } = await request.customer.free.countSelectFreeCountByType({ type: 1 })
    if (currentAvailableQuantity === 0) {
      open()
      return false
    }
    return true
  }
  return true
}

expose({
  open,
  close,
  check
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    width: 500,
    "close-on-click-modal": false,
    "custom-class": "order-exhausted-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('很抱歉，本月采购次数已用完')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('非会员每月仅限2次采购机会，升级会员后不限次数。')), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(t)('非会员首次开通9800标准仓会员，首月仅需0元。')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          round: "",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          round: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$router.push(_unref(useRtfix)('VipLevel')); close();})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('去升级')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})